import React from 'react';
import './PoliceverificationForm.css';
import Owner from './images/owner.jpg';


const PoliceVerificationForm = ({ student, onClose }) => {

  const formatDate = (dateString) => {
    if (!dateString) return 'Not provided';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="pvf-overlay" onClick={onClose}>
      <div className="pvf-wrapper" onClick={(e) => e.stopPropagation()}>
        <div className="pvf-action-buttons pvf-no-print">
          <button className="pvf-btn" onClick={handlePrint}>🖨️ Print</button>
          <button className="pvf-btn pvf-btn-close" onClick={onClose}>✕ Close</button>
        </div>

        <div className="pvf-form-container">
          <div className="pvf-form-header">
            <div className="pvf-form-title">Tenant Verification Form</div>
            <div className="pvf-form-subtitle">Information about House Owner & Tenant</div>
          </div>

          <div className="pvf-station-info">
            <div>
              <strong>Name of Police Station:</strong>
              <span className="pvf-station-name">SABARMATI, Ahmedabad City</span>
            </div>
            <div className="pvf-date-field">
              <strong>Date:</strong> {formatDate(new Date())}
            </div>
          </div>

          <div className="pvf-instruction-box">
            <strong>Important Instructions:</strong><br />
            • Details of each address should be filled up with PIN code and complete postal address with Telephone No. and Mobile No.<br />
            • Tenant's any one ID proof (e.g., AADHAR Card or Driving Licence) is to be compulsorily attached.
          </div>

          {/* HOUSE OWNER DETAILS */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">1</div>
              <span>DETAILS OF THE HOUSE OWNER</span>
            </div>

            <div className="pvf-photo-section">
              <div className="pvf-photo-box">
                <img
                  src={Owner}
                  alt="Owner Photo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE4MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE4MCIgZmlsbD0iIzFCM0I1RiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE0IiBmaWxsPSJ3aGl0ZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPk93bmVyIFBob3RvPC90ZXh0Pjwvc3ZnPg==';
                  }}
                />
              </div>
              <div className="pvf-details-grid">
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Name & Father's Name:</div>
                  <div className="pvf-field-value">Pradeep Suganchand Kawdiya</div>
                </div>
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Age:</div>
                  <div className="pvf-field-value">70 years</div>
                </div>
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Residential Address:</div>
                  <div className="pvf-field-value">
                    <div className="pvf-address-block">
                      201 Pratistha App.<br />
                      Opp. Nirma School, Bodakdev<br />
                      Vastrapur, Ahmedabad - 380054
                    </div>
                  </div>
                </div>
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Telephone & Mobile No.:</div>
                  <div className="pvf-field-value">9925151640</div>
                </div>
              </div>
            </div>
          </div>

          {/* PROPERTY DETAILS */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">2</div>
              <span>RENTED PROPERTY DETAILS</span>
            </div>

            <div className="pvf-field-row">
              <div className="pvf-field-label">Purpose of Rent:</div>
              <div className="pvf-field-value">Residence ☑ / Shop ☐ / Office ☐ / Godown ☐ / Factory ☐</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Property Name:</div>
              <div className="pvf-field-value">OMKARA HOSTEL</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Complete Address:</div>
              <div className="pvf-field-value">
                <div className="pvf-address-block">
                  OMKARA IMPEX AND MERCHANDISE LLP<br />
                  Near Adani Pratham, Behind Nirma University<br />
                  S. G. Highway to Village Tragad Road<br />
                  Ahmedabad, Gujarat - 382470<br />
                  www.omkarahostel.com
                </div>
              </div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Built-up Area:</div>
              <div className="pvf-field-value">____________________</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">No. of Rooms on Rent:</div>
              <div className="pvf-field-value">____________________</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Date of Rent Agreement:</div>
              <div className="pvf-field-value">{formatDate(student.createdAt)}</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Monthly Rent:</div>
              <div className="pvf-field-value">Rs. ____________________</div>
            </div>
          </div>

          {/* TENANT DETAILS */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">3</div>
              <span>DETAILS OF THE TENANT</span>
            </div>

            <div className="pvf-photo-section">
              <div className="pvf-photo-box">
                <img src={student.photoUrl || "https://i.pravatar.cc/150?img=12"} alt="Tenant Photo" />
              </div>
              <div className="pvf-details-grid">
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Name & Father's Name:</div>
                  <div className="pvf-field-value">{student.fullName} S/o {student.fatherName || 'N/A'}</div>
                </div>
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Age:</div>
                  <div className="pvf-field-value">{calculateAge(student.dob)} years</div>
                </div>
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Current Residential Address:</div>
                  <div className="pvf-field-value">
                    <div className="pvf-address-block">
                      OMKARA IMPEX AND MERCHANDISE LLP<br />
                      Near Adani Pratham, Behind Nirma University<br />
                      S. G. Highway to Village Tragad Road<br />
                      Ahmedabad, Gujarat - 382470
                    </div>
                  </div>
                </div>
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Telephone & Mobile No.:</div>
                  <div className="pvf-field-value">{student.mobile}</div>
                </div>
                <div className="pvf-field-row">
                  <div className="pvf-field-label">Email Address:</div>
                  <div className="pvf-field-value">{student.email}</div>
                </div>
              </div>
            </div>
          </div>

          {/* FAMILY MEMBERS AT CURRENT ADDRESS */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">4</div>
              <span>FAMILY MEMBERS AT CURRENT ADDRESS</span>
            </div>

            <table className="pvf-table">
              <thead>
                <tr>
                  <th style={{ width: '60px' }}>Sr. No.</th>
                  <th>Relation</th>
                  <th>Name & Father's Name</th>
                  <th>Mobile No.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Self</td>
                  <td>{student.fullName}</td>
                  <td>{student.mobile}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* PERMANENT ADDRESS */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">5</div>
              <span>PERMANENT ADDRESS OF TENANT</span>
            </div>

            <div className="pvf-address-block" style={{ margin: 0, padding: '20px' }}>
              <strong>Address:</strong><br />
              {student.permanentAddress?.address1 || 'Not provided'}<br />
              {student.permanentAddress?.address2 && <>{student.permanentAddress.address2}<br /></>}
              {student.permanentAddress?.city || 'Not provided'} - {student.permanentAddress?.zipcode || 'Not provided'}<br />
              {student.permanentAddress?.state || 'Not provided'}, {student.permanentAddress?.country || 'India'}<br /><br />
              <strong>Telephone & Mobile:</strong> {student.emergencyContact || student.fatherMobile || 'Not provided'}
            </div>
          </div>

          {/* FAMILY AT PERMANENT ADDRESS */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">6</div>
              <span>FAMILY MEMBERS AT PERMANENT ADDRESS</span>
            </div>

            <table className="pvf-table">
              <thead>
                <tr>
                  <th style={{ width: '60px' }}>Sr. No.</th>
                  <th>Relation</th>
                  <th>Name & Father's Name</th>
                  <th>Mobile No.</th>
                </tr>
              </thead>
              <tbody>
                {student.fatherName && (
                  <tr>
                    <td>1</td>
                    <td>Father</td>
                    <td>{student.fatherName}</td>
                    <td>{student.fatherMobile || 'Not provided'}</td>
                  </tr>
                )}
                {student.motherName && (
                  <tr>
                    <td>2</td>
                    <td>Mother</td>
                    <td>{student.motherName}</td>
                    <td>{student.motherMobile || 'Not provided'}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* NATIVE PLACE */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">7</div>
              <span>NATIVE PLACE OF TENANT</span>
            </div>

            <div className="pvf-address-block" style={{ margin: 0, padding: '20px' }}>
              <strong>Village/City:</strong> {student.nativeRegion || student.permanentAddress?.city || 'Not provided'}<br />
              <strong>District:</strong> {student.permanentAddress?.city || 'Not provided'}<br />
              <strong>State:</strong> {student.permanentAddress?.state || 'Not provided'}<br />
              <strong>PIN Code:</strong> {student.permanentAddress?.zipcode || 'Not provided'}<br /><br />
              <strong>Telephone & Mobile:</strong> {student.emergencyContact || student.mobile}
            </div>
          </div>

          {/* PREVIOUS ADDRESS */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">8</div>
              <span>PREVIOUS RESIDENCE (BEFORE CURRENT PREMISES)</span>
            </div>

            <div className="pvf-field-row">
              <div className="pvf-field-label">Previous House Owner Name:</div>
              <div className="pvf-field-value">{student.fatherName ? `${student.fatherName} (Father)` : 'Not provided'}</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Previous Address:</div>
              <div className="pvf-field-value">
                <div className="pvf-address-block">
                  {student.currentAddress?.address1 || student.correspondenceAddress?.address1 || student.permanentAddress?.address1 || 'Not provided'}<br />
                  {(student.currentAddress?.address2 || student.correspondenceAddress?.address2 || student.permanentAddress?.address2) && (
                    <>{student.currentAddress?.address2 || student.correspondenceAddress?.address2 || student.permanentAddress?.address2}<br /></>
                  )}
                  {student.currentAddress?.city || student.correspondenceAddress?.city || student.permanentAddress?.city || 'Not provided'} - {student.currentAddress?.zipcode || student.correspondenceAddress?.zipcode || student.permanentAddress?.zipcode || 'Not provided'}, {student.currentAddress?.state || student.correspondenceAddress?.state || student.permanentAddress?.state || 'Not provided'}
                </div>
              </div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Contact Number:</div>
              <div className="pvf-field-value">{student.fatherMobile || student.emergencyContact || 'Not provided'}</div>
            </div>
          </div>

          {/* ID PROOF */}
          <div className="pvf-section">
            <div className="pvf-section-header">
              <div className="pvf-section-number">9</div>
              <span>TENANT'S IDENTIFICATION DOCUMENTS</span>
            </div>

            <div className="pvf-field-row">
              <div className="pvf-field-label">Aadhar Card Number:</div>
              <div className="pvf-field-value">{student.aadhar || 'Not provided'}</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Driving Licence Number:</div>
              <div className="pvf-field-value">{student.drivingLicense || 'Not provided'}</div>
            </div>
            <div className="pvf-field-row">
              <div className="pvf-field-label">Passport Number:</div>
              <div className="pvf-field-value">{student.passport || 'Not provided'}</div>
            </div>
            <div style={{ marginTop: '15px', fontSize: '13px', color: '#666', fontStyle: 'italic' }}>
              ✓ Aadhar Card copy attached
            </div>
          </div>

          {/* SIGNATURES */}
          <div className="pvf-signature-section">
            <div className="pvf-signature-box">
              <div className="pvf-signature-line">
                Signature of House Owner<br />
                <small style={{ fontWeight: 'normal' }}>(Pradeep Suganchand Kawdiya)</small>
              </div>
            </div>
            <div className="pvf-signature-box">
              <div className="pvf-signature-line">
                Signature of Tenant<br />
                <small style={{ fontWeight: 'normal' }}>({student.fullName})</small>
              </div>
            </div>
          </div>

          <div style={{ marginTop: '50px', padding: '20px', background: '#f0f0f0', borderLeft: '4px solid var(--primary-navy)' }}>
            <strong>For Office Use Only</strong><br /><br />
            Verified By: ____________________<br /><br />
            Police Station Stamp: <br /><br /><br /><br />
            Date: ____________________
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliceVerificationForm;